<template>
	<div>
		<!-- 面包屑导航 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item>协议详情</el-breadcrumb-item>
		</el-breadcrumb>
		<el-divider content-position="left">用户协议:</el-divider>

		<div style="border: 1px solid #ccc; margin-top: 2vh; width: 90%">
			<Toolbar style="border-bottom: 1px solid #ccc" :editor="editor" :defaultConfig="toolbarConfig"
				:mode="mode" />
			<Editor style="height: 500px; overflow-y: hidden" v-model="html2" :defaultConfig="editorConfig" :mode="mode"
				@onCreated="onCreated" />
		</div>
		<el-divider content-position="left">隐私协议:</el-divider>
		<div style="border: 1px solid #ccc; margin-top: 5vh; width: 90%">
			<Toolbar style="border-bottom: 1px solid #ccc" :editor="editors" :defaultConfig="toolbarConfigs"
				:mode="mode" />
			<Editor style="height: 500px; overflow-y: hidden" v-model="html" :defaultConfig="editorConfigs" :mode="mode"
				@onCreated="onCreateds" />
		</div>
		<el-button type="primary" @click="rightsubmit" style="margin-top: 2vh">确认修改</el-button>
	</div>
</template>
<script>
	import Vue from "vue";
	import {
		Editor,
		Toolbar
	} from "@wangeditor/editor-for-vue";
	import {
		getCookie
	} from "../../utils/util";
	import {
		getBaseList,
		getruleMsg,
		editruleMsg
	} from "../../api/base";

	export default Vue.extend({
		components: {
			Editor,
			Toolbar
		},
		data() {
			return {
				editor: null,
				editors: null,
				html: "",
				html2: "",
				toolbarConfig: {
					excludeKeys: ["group-video"],
				},
				toolbarConfigs: {},
				editorConfigs: {
					placeholder: "请输入内容...",
					MENU_CONF: {
						uploadImage: {
							server: process.env.VUE_APP_URL + "/admin/uploadFile",
							fieldName: "file",
							// 上传头文件
							headers: {
								Authorization: "Bearer " + getCookie("logintoken"),
							},
							customInsert(res, insertFn) {
								// JS 语法
								const urls = res.data.path;
								insertFn(urls);
							},
						},
					},
				},
				editorConfig: {
					placeholder: "请输入内容...",
					MENU_CONF: {
						uploadImage: {
							server: process.env.VUE_APP_URL + "/admin/uploadFile",
							fieldName: "file",
							// 上传头文件
							headers: {
								Authorization: "Bearer " + getCookie("logintoken"),
							},
							customInsert(res, insertFn) {
								// JS 语法
								const urls = res.data.path;
								insertFn(urls);
							},
						},
					},
				},
				mode: "default", // or 'simple'
			};
		},
		mounted() {
			this.getbaseLists();
			this.getruleMsgs();
		},
		methods: {
			// 提交协议详情
			rightsubmit() {
				const editMsg = {
					regist_rule: this.html2,
					privacy_rule: this.html,
					id: 1,
				};
				editruleMsg(editMsg).then((res) => {
					if (res.code == 200) {
						this.$message.success("修改成功！");
						this.getruleMsgs();
					} else {
						this.$message.error("修改失败！");
					}
				});
			},
			//获取协议详情
			getruleMsgs() {
				const searchForm = {
					id: 1,
				};
				getruleMsg(searchForm).then((res) => {
					this.html = res.data.privacy_rule;
					this.html2 = res.data.regist_rule;
				});
			},
			onCreated(editor) {
				this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
			},
			onCreateds(editors) {
				this.editors = Object.seal(editors); // 一定要用 Object.seal() ，否则会报错
			},
			// 获取配置
			getbaseLists() {
				getBaseList().then((res) => {
					console.log(res);
				});
			},
		},

		beforeDestroy() {
			const editor = this.editor;
			if (editor == null) return;
			editor.destroy(); // 组件销毁时，及时销毁编辑器
		},
	});
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>


// WEBPACK FOOTER //
// src/views/base/index.vue